import LocalizedStrings from 'react-localization';

export default new LocalizedStrings({
    en: {
        userBelogsPlatform: 'Your user already belongs to this platform',
        invitationAccepted: 'Invitation accepted!',
        couldNotAcceptInvitation: 'Could not accept this invitation',
        tokenExpired: 'The invitation has expired',
        welcome: 'Welcome!',
        youVeBeenInvited: 'You have been invited to join the following Platform:',
        accept: 'Accept',
        home: 'Home',
        meet: 'Meet',
        notifications: 'Notifications',
        favorites: 'Favorites',
        tools: 'Tools',
        hi: 'Hi',
        accessInside: 'Navigation',
        searchOfflineError: 'Search is not available because the device is offline.',
        search: 'Find what you are looking for',
        activeFilters: 'Active Filters:',
        noResults: '-- No results available --',
        contents: 'Contents',
        images: 'Images',
        videos: 'Videos',
        files: 'Files',
        userSettings: 'User Settings',
        done: 'Done',
        changePlatform: 'Change platform:',
        language: 'Language',
        logout: 'Log out',
        changePassword: 'Change Password',
        oldPassword: 'Old password',
        deviceOfflineError: 'This option is not available because the device is offline.',
        errorChangePassword: 'Error trying to change password',
        passwordChanged: 'Password changed!',
        errorPasswordFormat: 'new password does not provide all parameters',
        oldPasswordEmptyError: 'Please fill in the old password',
        mtgFilterAll: 'All',
        mtgFilterPriority: 'Priority',
        noMtgs: '-- No meetings available --',
        noCols: '-- No collections available --',
        close: 'Close',
        name: 'Name',
        email: 'Email',
        mtgDate: 'Meeting date',
        previewImage: 'Preview Image',
        pickPreview: 'Pick a preview image',
        editImage: 'Edit Image',
        addImage: 'Add Image',
        removeImage: 'Remove Image',
        chooseCollection: 'Choose existing Collection',
        createCollection: 'Create a new Collection',
        summary: 'Data Summary',
        noDefined: 'None defined',
        resources: 'Resources',
        creationProcess: 'Processing creation',
        creating: 'Creating element',
        composing: 'Composing content',
        preparing: 'Preparing preview image',
        publishing: 'Publishing element',
        processErrors: 'Process finished with errors',
        processSucceed: 'Process succeeded',
        finish: 'Finish',
        firstStep: 'Enter base data',
        secondStep: 'Add content',
        create: 'Create',
        chooseStep: 'Content origin',
        next: 'Next',
        back: 'Back',
        notes: 'Notes',
        lastUpdated: 'Last updated',
        attachments: 'Attachments',
        tryDrop: 'Try dropping some files here, or click to select files to upload.',
        structure: 'Structure',
        addContent: 'Add selected content',
        createNotification: 'Create a Notification',
        noNotifications: "Nothing to see here, you don't have notifications!",
        chooseNotification: 'Choose a notification',
        editor: 'Editor',
        editorDescription: 'Access editor mode',
        library: 'Library',
        libraryDescription: 'Direct access to Library',
        notificationsDescription: 'Create and send Notifications',
        users: 'Users',
        usersDescription: 'Create users and manage user groups',
        shares: 'Shared',
        sharesDescription: 'Manage the content you shared',
        publish: 'Publish',
        publishDescription: 'Publish pending content',
        downloadApp: 'Download App',
        analytics: 'Analytics',
        analyticsDescription: 'Metrics about the platform usage',
        forms: 'Forms',
        formsDescription: 'Create and manage forms',
        downloadAppFor: 'Download app for',
        noAppAvailable: 'App not avaliable for your device type',
        contentUpdate: 'Content update',
        theContent: 'The content',
        updated: 'has been updated',
        visibilities: 'Visibility',
        exportData: 'Export Data',
        share: 'Share',
        viewDownload: 'View / Download',
        downloadOrShareTitle: 'This file can not be opened within the platform',
        downloadOrShareDescription: 'To open this file you can download it on your device or you can directly share it from here.',
        errorFetchAttachents: 'Could not fetch attachments, the file might not be shareable.',
        errorShareLink: 'Error creating shareable link',
        errorShareable: 'is not shareable',
        errorMailEmpty: 'e-Mail is empty',
        errorMailInvalid: 'e-Mail is not valid',
        errorReferenceEmpty: 'Reference is empty',
        errorSubjectEmpty: 'Subject is empty',
        errorMessageEmpty: 'Message is empty',
        sendingMessage: 'Sending...',
        messageSent: 'Message sent',
        errorSending: 'Could not sent the message',
        tabMail: 'Mail',
        tabExternal: 'External App',
        mailField: 'Email Address',
        referenceField: 'Reference',
        subjectField: 'Subject',
        messageField: 'Message',
        footerField: 'Footer',
        cancel: 'Cancel',
        shareLinks: 'Share Links',
        onlyFiles: 'Share Only Files',
        alertMizedContent: 'You have contents and files selected, and only the files will be shared!',
        attachmentAdded: 'Attachment Added!',
        profileDetails: 'My profile',
        fullName: 'Full name',
        company: 'Company',
        salute: 'Salutation',
        mr: 'Mr.',
        mrs: 'Mrs.',
        position: 'Position',
        country: 'Country',
        city: 'City',
        area: 'Area',
        area_inside_sales: 'Inside Sales',
        area_outdoor_sales: 'Outdoor Sales',
        area_marketing: 'Marketing',
        area_management: 'Management',
        area_product: 'Product',
        area_other: 'Other, please detail',
        area_other_fill: 'Other area',
        updateUserProfileData: 'Update profile information',
        updateUserProfileDataOK: 'User profile information updated',
        updateUserProfileDataError: 'Could not update user profile information, please check all fields are correct',

        shareLinksNotIncluded:
            'Please note, for security purposes, links to structure or metadocuments will not be shared externally when sharing the Meeting or Collection via email.',
        shareFooter: 'Best regards,',
    },
    es: {
        userBelogsPlatform: 'El usuario ya forma parte de esta plataforma',
        invitationAccepted: '¡Invitación aceptada!',
        couldNotAcceptInvitation: 'No se ha podido aceptar la invitación',
        tokenExpired: 'La invitación ha caducado',
        welcome: '¡Bienvenido!',
        youVeBeenInvited: 'Ha sido invitado a unirse a la siguiente plataforma:',
        accept: 'Aceptar',
        home: 'Home',
        meet: 'Meet',
        notifications: 'Notificaciones',
        favorites: 'Favoritos',
        tools: 'Herramientas',
        hi: 'Hola',
        accessInside: 'Acceder',
        searchOfflineError: 'La búsqueda no está disponible debido a que el dispositivo no está conectado a internet.',
        search: 'Encuentra lo que estas buscando',
        activeFilters: 'Filtros Activos:',
        noResults: '-- No hay resultados disponibles --',
        contents: 'Contenidos',
        images: 'Imágenes',
        videos: 'Videos',
        files: 'Ficheros',
        userSettings: 'Configuración de usuario',
        done: 'Salir',
        changePlatform: 'Cambiar de plataforma:',
        language: 'Idioma',
        logout: 'Cerrar Sesión',
        changePassword: 'Cambiar Contraseña',
        oldPassword: 'Contraseña antigua',
        deviceOfflineError: 'Esta opción no está disponible debido a que el dispositivo no está conectado a internet.',
        errorChangePassword: 'Error cambiando la contraseña',
        passwordChanged: 'Contraseña cambiada!',
        errorPasswordFormat: 'La nueva contraseña no cumple todas las condiciones',
        oldPasswordEmptyError: 'Por favor, escriba la contraseña antigua',
        mtgFilterAll: 'Todos',
        mtgFilterPriority: 'Prioritarios',
        noMtgs: '-- No hay meetings disponibles --',
        noCols: '-- No hay collections disponibles --',
        close: 'Cerrar',
        name: 'Nombre',
        email: 'Correo electrónico',
        mtgDate: 'Fecha de la reunión',
        previewImage: 'Imagen Previa',
        pickPreview: 'Escoja una imagen previa',
        editImage: 'Editar Imagen',
        addImage: 'Añadir Imagen',
        removeImage: 'Borrar Imagen',
        chooseCollection: 'Escoger Collection existente',
        createCollection: 'Crear una nueva Collection',
        summary: 'Resumen de datos',
        noDefined: 'No definido',
        resources: 'Recursos',
        creationProcess: 'Proceso de creación',
        creating: 'Creando elemento',
        composing: 'Componiendo contenido',
        preparing: 'Preparando imagen previa',
        publishing: 'Publicando elemento',
        processErrors: 'Proceso acabado con errores',
        processSucceed: 'Proceso completado con éxito',
        finish: 'Acabar',
        firstStep: 'Introduzca información básica',
        secondStep: 'Añada contenido',
        create: 'Crear',
        chooseStep: 'Origen del contenido',
        next: 'Siguiente',
        back: 'Atrás',
        notes: 'Notas',
        lastUpdated: 'Última actualización',
        attachments: 'Ficheros Adjuntos',
        tryDrop: 'Prueba a tirar ficheros aquí, o haz clic para seleccionar ficheros.',
        structure: 'Estructura',
        addContent: 'Añadir contenido seleccionado',
        createNotification: 'Crear una notificación',
        noNotifications: 'No tienes notificaciones',
        chooseNotification: 'Seleccione una notificación',
        editor: 'Editor',
        editorDescription: 'Acceso al modo editor',
        library: 'Biblioteca',
        libraryDescription: 'Acceso directo a la biblioteca',
        notificationsDescription: 'Crea y envía notificaciones',
        users: 'Usuarios',
        usersDescription: 'Crea usuarios o grupos de usuarios',
        shares: 'Compartidos',
        sharesDescription: 'Administre los contenidos compartidos',
        publish: 'Publicar',
        publishDescription: 'Publique contenido pendiente',
        downloadApp: 'Descargar App',
        analytics: 'Analítica',
        analyticsDescription: 'Métricas sobre el uso de la plataforma',
        forms: 'Formularios',
        formsDescription: 'Cree y gestione formularios',
        downloadAppFor: 'Descargue la app para',
        noAppAvailable: 'No hay ninguna app compatible con el dispositivo',
        contentUpdate: 'Actualización de contenido',
        theContent: 'El contenido',
        updated: 'ha sido actualizado',
        visibilities: 'Visibilidad',
        exportData: 'Exportar Datos',
        share: 'Compartir',
        viewDownload: 'Ver / Descargar',
        downloadOrShareTitle: 'Este fichero no puede mostrarse dentro de la plataforma',
        downloadOrShareDescription:
            'Para abrir el fichero puedes descargarlo en tu dispositivo o bien compartirlo directamente des de aquí.',
        errorFetchAttachents: 'No se ha podido cargar el archivo, el fichero podría no ser compartible.',
        errorShareLink: 'Error al crear el enlace compartible',
        errorShareable: 'no es compartible',
        errorMailEmpty: 'El email está vacío',
        errorMailInvalid: 'El email no es valido',
        errorReferenceEmpty: 'La referencia está vacía',
        errorSubjectEmpty: 'El asunto está vacío',
        errorMessageEmpty: 'El mensaje está vacío',
        sendingMessage: 'Enviando...',
        messageSent: 'Mensaje enviado',
        errorSending: 'El mensaje no se ha podido enviar',
        tabMail: 'Email',
        tabExternal: 'App Externa',
        mailField: 'Dirección Email',
        referenceField: 'Referencia',
        subjectField: 'Asunto',
        messageField: 'Mensaje',
        footerField: 'Pie de mensaje',
        cancel: 'Cancelar',
        shareLinks: 'Compartir Enlaces',
        onlyFiles: 'Compartir solo ficheros',
        alertMizedContent: 'Tienes contenidos y ficheros seleccionados, y solo se compartirán los ficheros!',
        attachmentAdded: '¡Adjunto añadido!',
        profileDetails: 'Mi perfil',
        fullName: 'Nombre y apellidos',
        company: 'Empresa',
        salute: 'Tratamiento',
        mr: 'Sr.',
        mrs: 'Sra.',
        position: 'Cargo',
        country: 'País',
        city: 'Ciudad',
        area: 'Área operativa',
        area_inside_sales: 'Vendedor interno',
        area_outdoor_sales: 'Vendedor de campo',
        area_marketing: 'Márqueting',
        area_management: 'Dirección',
        area_product: 'Producto',
        area_other: 'Otra, por favor indíquela',
        area_other_fill: 'Otra área',
        updateUserProfileData: 'Actualizar datos de usuario',
        updateUserProfileDataOK: 'Datos de usuario actualizados correctamente',
        updateUserProfileDataError:
            'No se han podido actualizar datos de usuario. Por favor, compruebe que todos los campos sean correctos',

        shareLinksNotIncluded:
            'Tenga en cuenta que, por motivos de seguridad, los enlaces a la estructura o los metadocumentos no se compartirán externamente cuando se comparta la reunión o la colección por correo electrónico.',
        shareFooter: 'Atentamente,',
    },
    de: {
        userBelogsPlatform: 'Ihr User ist bereits für diese Plattform registriertE',
        invitationAccepted: 'Einladung angenommen!',
        couldNotAcceptInvitation: 'Ihre Einladung konnte nicht angenommen werden',
        tokenExpired: 'Die Einladung ist nicht mehr gültig',
        welcome: 'Willkommen!',
        youVeBeenInvited: 'Sie wurden zur folgenden Plattform eingeladen',
        accept: 'Sie wurden zur folgenden Plattform eingeladen',
        home: 'Startseite',
        meet: 'Meetings',
        notifications: 'Benachrichtigungen',
        favorites: 'Favoriten',
        tools: 'Tools',
        hi: 'Hallo',
        accessInside: 'Zugang',
        searchOfflineError: 'Die Suche ist nicht verfügbar, da das Gerät offline ist.',
        search: 'Finden Sie hier, wonach Sie suchen',
        activeFilters: 'Aktive Filter',
        noResults: '-- No results available --',
        contents: 'Inhalte',
        images: 'Bilder',
        videos: 'Videos',
        files: 'Dateien',
        userSettings: 'User-Einstellungen',
        done: 'Erledigt',
        changePlatform: 'Plattform wechseln',
        language: 'Language',
        logout: 'Abmelden',
        changePassword: 'Passwort ändern',
        oldPassword: 'Altes Passwort',
        deviceOfflineError: 'Diese Option ist nicht verfügbar, da das Gerät offline ist.',
        errorChangePassword: 'Fehler beim Versuch, das Passwort zu ändern',
        passwordChanged: 'Passwort geändert!',
        errorPasswordFormat: 'Das neue Passwort entspricht nicht den Vorgaben',
        oldPasswordEmptyError: 'Altes Passwort eingeben',
        mtgFilterAll: 'Alle',
        mtgFilterPriority: 'Die wichtigsten',
        noMtgs: 'Keine Meetings verfügbar',
        noCols: 'Keine Collections verfügbar',
        close: 'Schließen',
        name: 'Name',
        email: 'E-Mail',
        mtgDate: 'Datum Meeting',
        previewImage: 'Vorschaubild',
        pickPreview: 'Vorschaubild auswählen',
        editImage: 'Bild bearbeiten',
        addImage: 'Bild hinzufügen',
        removeImage: 'Bild entfernen',
        chooseCollection: 'Bestehende Collection auswählen',
        createCollection: 'Neue Collection erstellen',
        summary: 'Zusammenfassung',
        noDefined: 'Keine festgelegt',
        resources: 'Ressourcen',
        creationProcess: 'Verarbeitung der Erstellung',
        creating: 'Erstellen des Elements',
        composing: 'Inhalte zusammenstellen',
        preparing: 'Vorschaubild vorbereiten',
        publishing: 'Element veröffentlichen',
        processErrors: 'Vorgang mit Fehlern abgeschlossen',
        processSucceed: 'Vorgang erfolgreich',
        finish: 'Fertigstellung',
        firstStep: 'Basisdaten eingeben',
        secondStep: 'Inhalte hinzufügen',
        create: 'Erstellen',
        chooseStep: 'Inhaltsherkunft',
        next: 'Nächster Schritt',
        back: 'Zurück',
        notes: 'Notizen',
        lastUpdated: 'Zuletzt aktualisiert',
        attachments: 'Anhänge',
        tryDrop: 'Versuchen Sie hier einige Dateien einzufügen oder klicken Sie, um Dateien hochzuladen',
        structure: 'Struktur',
        addContent: 'Ausgewählten Inhalt hinzufügen',
        createNotification: 'Benachrichtigung erstellen',
        noNotifications: 'Hier gibt es nichts zu sehen, Sie haben keine Benachrichtigungen!',
        chooseNotification: 'Wählen Sie eine Benachrichtigung',
        editor: 'Editor',
        editorDescription: 'In den Editor-Modus wechseln',
        library: 'Bibliothek',
        libraryDescription: 'Direkter Zugriff auf die Bibliothek',
        notificationsDescription: 'Erstellen und Versenden von Benachrichtigungen',
        users: 'User',
        usersDescription: 'User erstellen und User-Gruppen verwalten',
        shares: 'Geteilt',
        sharesDescription: 'Verwalten Sie Ihre geteilten Inhalte',
        publish: 'Veröffentlichen',
        publishDescription: 'Ausstehende Inhalte veröffentlichen',
        downloadApp: 'App-Download',
        analytics: 'Analytics',
        analyticsDescription: 'Kennzahlen zur Plattformnutzung',
        downloadAppFor: 'App herunterladen für',
        noAppAvailable: 'App nicht für Ihren Gerätetyp verfügbar',
        contentUpdate: 'Inhalte aktualisieren',
        theContent: 'Der Inhalt',
        updated: 'wurde aktualisiert',
        visibilities: 'Sichtbarkeit',
        exportData: 'Daten exportieren',
        share: 'Teilen',
        viewDownload: 'Ansicht/Download',
        downloadOrShareTitle: 'Diese Datei kann in diesem System nicht geöffnet werden',
        downloadOrShareDescription: 'Um die Datei zu öffnen, können Sie diese auf Ihr Gerät herunterladen oder direkt von hier aus teilen.',
        errorFetchAttachents: 'Anhänge sind nicht abrufbar, die Datei kann möglicherweise nicht geteilt werden',
        errorShareLink: 'Fehler beim Erstellen eines Links zum Teilen',
        errorShareable: 'ist nicht teilbar',
        errorMailEmpty: 'E-Mail ist leer',
        errorMailInvalid: 'E-Mail ist nicht gültig',
        errorReferenceEmpty: 'Referenz ist leer',
        errorSubjectEmpty: 'Betreff ist leer',
        errorMessageEmpty: 'Nachricht ist leer',
        sendingMessage: 'Senden…',
        messageSent: 'Nachricht gesendet',
        errorSending: 'Nachricht konnte nicht gesendet werden',
        tabMail: 'E-Mail',
        tabExternal: 'Externe App',
        mailField: 'E-Mail-Adresse',
        referenceField: 'Referenz',
        subjectField: 'Betreff',
        messageField: 'Nachricht',
        footerField: 'Fußzeile der Nachricht',
        cancel: 'Abbruch',
        shareLinks: 'Links teilen',
        onlyFiles: 'Nur Dateien teilen',
        alertMizedContent: 'Sie haben Inhalte und Dateien ausgewählt, es werden aber nur die Dateien geteilt!',
        attachmentAdded: 'Anhang hinzugefügt!',
        profileDetails: 'Mein Profil',
        fullName: 'Vollständiger Name',
        company: 'Firma',
        salute: 'Anrede',
        mr: 'Herr',
        mrs: 'Frau',
        position: 'Position',
        country: 'Land',
        city: 'Ort',
        area: 'Bereich',
        area_inside_sales: 'Vertrieb Innendienst',
        area_outdoor_sales: 'Vertrieb Außendienst',
        area_marketing: 'Marketing',
        area_management: 'Management',
        area_product: 'Produktbereich',
        area_other: 'Andere, bitte genauere Angaben',
        area_other_fill: 'Anderer Bereich',
        updateUserProfileData: 'Profilinformationen aktualisieren',
        updateUserProfileDataOK: 'User-Profilinformationen aktualisiert',
        updateUserProfileDataError:
            'Die User-Profilinformationen konnten nicht aktualisiert werden. Bitte überprüfen Sie, ob alle Angaben korrekt sind.',

        shareLinksNotIncluded:
            'Bitte beachten Sie, dass aus Sicherheitsgründen Links zu Strukturen oder Metadokumenten nicht extern freigegeben werden, wenn die Besprechung oder Sammlung per E-Mail freigegeben wird.',
        shareFooter: 'Freundliche Grüße,',
    },
    fr: {
        userBelogsPlatform: 'Votre utilisateur appartient déjà à cette plateforme',
        invitationAccepted: 'Invitation acceptée!',
        couldNotAcceptInvitation: "Impossible d'accepter cette invitation",
        tokenExpired: "L'invitation a expiré",
        welcome: 'Bienvenue!',
        youVeBeenInvited: 'Vous êtes invité à rejoindre la plateforme',
        accept: 'Accepter',
        home: 'Home',
        meet: 'Meet',
        notifications: 'Notifications',
        favorites: 'Favoris',
        tools: 'Outils',
        hi: 'Bonjour',
        accessInside: 'Accès',
        searchOfflineError: "Recherche indisponible car l'application n'est pas connectée.",
        search: 'Recherchez',
        activeFilters: 'Filtres actifs',
        noResults: 'Aucun résultat disponible',
        contents: 'Contenus',
        images: 'Images',
        videos: 'Videos',
        files: 'Fichiers',
        userSettings: 'Réglages utilisateur',
        done: 'OK',
        changePlatform: 'Changer de plateforme',
        language: 'Language',
        logout: 'Log out',
        changePassword: 'Changer de mot de passe',
        oldPassword: 'Ancien mot de passe',
        deviceOfflineError: "Cette option n'est pas disponible car l'application n'est pas connectée.",
        errorChangePassword: "Erreur lors de l'enregistrement du nouveau mot de passe",
        passwordChanged: 'Mot de passe modifié!',
        errorPasswordFormat: 'Le nouveau mot de passe ne respecte pas tous les paramètres obligatoires',
        oldPasswordEmptyError: "Merci renseigner l'ancien mot de passe",
        mtgFilterAll: 'tous',
        mtgFilterPriority: 'Prioritaire',
        noMtgs: '-- Pas de rendez-vous disponible --',
        noCols: '-- Pas de collection disponible --',
        close: 'Fermeture',
        name: 'Nom',
        email: 'Email',
        mtgDate: 'Date de rendez-vous',
        previewImage: "Previsualiser l'image",
        pickPreview: "Sélectionner une prévisualisation d'image",
        editImage: "Editer l'image",
        addImage: 'Ajouter une image',
        removeImage: "Enlever l'image",
        chooseCollection: 'Choisir une collection existante',
        createCollection: 'Créer une nouvelle collection',
        summary: 'Sommaire données',
        noDefined: "Rien n'a été défini",
        resources: 'Ressources',
        creationProcess: 'Création en cours',
        creating: "Création d'un élément",
        composing: 'Composing content',
        preparing: 'Preparer une image en prévisualisation',
        publishing: 'Publier un élément',
        processErrors: 'Process terminé comportant des erreurs',
        processSucceed: 'Process réussi',
        finish: 'Terminé',
        firstStep: 'Entrer dans la base de données',
        secondStep: 'Ajouter du contenu',
        create: 'Créer',
        chooseStep: 'Origine du contenu',
        next: 'Suivant',
        back: 'Précédent',
        notes: 'Notes',
        lastUpdated: 'Dernier chargement',
        attachments: 'Pièces jointes',
        tryDrop: 'Essayez de déplacer des fichiers ici, ou cliquez sur les fichier sélectionnées pour les charger.',
        structure: 'Structure',
        addContent: 'Ajouter le contenu sélectionné',
        createNotification: 'Créer une Notification',
        noNotifications: "Vous n'avez pas de notifications!",
        chooseNotification: 'Choisissez une notification',
        editor: 'Editeur',
        editorDescription: 'Accéder au mode éditeur',
        library: 'Bibliothèque',
        libraryDescription: 'Accès direct à la bibliothèque',
        notificationsDescription: 'Créer et envoyer des Notifications',
        users: 'Utilisateurs',
        usersDescription: "Créer des utilisateurs and gérer les groupes d'utilisateurs",
        shares: 'Partagé',
        sharesDescription: 'Gérer le contenu que vous partagez',
        publish: 'Publier',
        publishDescription: 'Publier du contenu en attente',
        downloadApp: "Télécharger l'App",
        analytics: 'Analytics',
        analyticsDescription: "Critères d'utilisation de la plateforme",
        downloadAppFor: "Téléchargez l'app",
        noAppAvailable: "L'App n'est disponible pour votre type d'appareil",
        contentUpdate: 'Mise à jour de contenu',
        theContent: 'Le contenu',
        updated: 'a été mis à jour',
        visibilities: 'Visibilité',
        exportData: 'Données à exporter',
        share: 'Partager',
        viewDownload: 'Visualiser / Télécharger',
        downloadOrShareTitle: 'Ce fichier ne peut pas être ouvert dans PDC',
        downloadOrShareDescription: 'Pour ouvrir ce fichier vous devez le télécharger sur votre appareil ou le partager.',
        errorFetchAttachents: 'Pièces jointes introuvables, le fichier ne peut être partagé.',
        errorShareLink: 'Erreur à la création du lien de partage',
        errorShareable: 'ne peut être partagé',
        errorMailEmpty: "L'e-Mail est vide",
        errorMailInvalid: "L'e-Mail n'est pas correct",
        errorReferenceEmpty: 'La reference est vide',
        errorSubjectEmpty: "L'Objet est vide",
        errorMessageEmpty: 'Message vide',
        sendingMessage: 'Envoyer...',
        messageSent: 'Message envoyé',
        errorSending: 'Message non envoyé',
        tabMail: 'Mail',
        tabExternal: 'App Externe',
        mailField: 'Adresse Email',
        referenceField: 'Reference',
        subjectField: 'Objet',
        messageField: 'Message',
        footerField: 'Pied de page du message',
        cancel: 'Annuler',
        shareLinks: 'Partager les liens',
        onlyFiles: 'Partager seulement les fichiers',
        alertMizedContent: 'Vous avez sélectionné des fichier et contenus, mais seuls les fichier ont été partagés!',
        attachmentAdded: 'Pièces jointes ajoutées!',
        profileDetails: 'Mon profil',
        fullName: 'Nom',
        company: 'Société',
        salute: 'Salutation',
        mr: 'Monsieur',
        mrs: 'Madame',
        position: 'Position',
        country: 'Pays',
        city: 'Ville',
        area: 'Secteur',
        area_inside_sales: 'Inside Sales',
        area_outdoor_sales: 'Outdoor Sales',
        area_marketing: 'Marketing',
        area_management: 'Management',
        area_product: 'Product management',
        area_other: 'Autre, merci préciser',
        area_other_fill: 'Autre secteur',
        updateUserProfileData: 'Mettre à jour le profil',
        updateUserProfileDataOK: 'Profil utilisateur mis à jour',
        updateUserProfileDataError: 'Mise à jour du profil impossible, merci vérifier que tous les champs sont corrects',

        shareLinksNotIncluded:
            'Veuillez noter que pour des raisons de sécurité, les liens vers la structure ou les métadocuments ne seront pas partagés en externe lors du partage de la réunion ou de la collection par e-mail.',
        shareFooter: 'Meilleures salutations,',
    },
});
